<template>
	<!-- Slider main container -->
	<div id="table4">
		<el-table :data="data" style="width: 100%;height: 100%;">
			<el-table-column prop="sbmc" label="名称">
			</el-table-column>
			<el-table-column label="图片">
				<template slot-scope="scope">					
					<img :src="scope.row.imgUrl" width="50" height="50" />
				</template>
			</el-table-column>
			<el-table-column prop="regId" label="注册号">
			</el-table-column>
			<el-table-column label="申请日">
				<template slot-scope="scope">
					{{ dateFormat(scope.row.appDate) }}
				</template>
			</el-table-column>
			<el-table-column label="有效期">
				<template slot-scope="scope">
					{{ dateFormat(scope.row.validDate) }}
				</template>
			</el-table-column>						
		</el-table>
	</div>
</template>

<script>
	export default {
		name: "swiper-list",
		data() {
			return {

			};
		},
		props: {
			page: {
				type: Number,
				default: () => 0,
			},
			intcls: {
				type: String,
				default: () => "",
			},
			data: {
				type: Array,
				default: () => [],
			},
			// 根据选择器来变换标题
			year: {
				type: String,
				default: () => "",
			},
		},
		mounted() {

		},
		methods: {
			dateFormat(date) {
				if (!date) return ''
				date = new Date(date)
				const year = date.getFullYear()
				const month = date.getMonth() + 1
				const day = date.getDate()
				return [year, month, day].map(this.formatNumber).join('-') 
			},
			formatNumber(n) {
				n = n.toString()
				return n[1] ? n : '0' + n
			}
		},
	};
</script>

<style scoped lang="less">
	#table4 {
		width: 100%;
		height: 100%;
		padding-top: 50px;
		.el-table, .el-table__expanded-cell {
			background: none;
		}
		.el-table::before {
			left: 0;
			top: 0px;
			width: 100%;
			height: 1px;
			background-color: #69B1FF;
		}
	}
</style>
<style lang="less">
	#table4 .el-table thead tr {		
		height: 78px;
		line-height: 78px;
		background-color: #1e427e;
	}
	#table4 .el-table tbody tr {		
		height: 78px;
		line-height: 78px;
		background: none;
		&:hover > td {
			background-color: #1e427e;
		}
	}
	
	#table4 .el-table th.el-table__cell {
		background: none;
		padding: 0;
	}
	#table4 .el-table .cell {
		font-size: 24px;
		color: #FFFFFF;
	}
	#table4 .el-table th .cell {
		line-height: 24px;
	}
	#table4 .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #69B1FF;
	}
	#table4 .el-table td.column3 .cell {
		color: #18FFB0 !important;
	}
</style>